import { render, staticRenderFns } from "./OxygenGroupInput.vue?vue&type=template&id=7521a346&"
import script from "./OxygenGroupInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenGroupInput.vue?vue&type=script&lang=ts&"
import style0 from "./OxygenGroupInput.vue?vue&type=style&index=0&id=7521a346&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports